<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt [value]="persons" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="personId"
  selectionMode="single" [(selection)]="person" (onRowSelect)="onRowSelect($event)"
  [loading]="loading" [paginator]="true" [rows]="25" [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true" class="edit_filterList">

  <ng-template pTemplate="caption">
    <div class="d-block text-end">
      <span>
        <!--clear filters-->
        <button pButton pRipple class="p-button-text"
          style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
        (click)="reloadPage()">Clear Filters</button>

        <!--add new-->
        <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
        (click)="onOpenFormAdd()">New Person +</button>
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
    <tr>
      <th class="personID"><input pInputText type="text" (input)="pt.filter($event.target.value, 'personId', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'firstName', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'lastName', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'suffix', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'title', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-person>
    <tr [pSelectableRow]="person">
      <td>{{person.personId}} </td>
      <td>{{person.firstName}}</td>
      <td>{{person.lastName}}</td>
      <td>{{person.suffix}}</td>
      <td>{{person.title}}</td>
      <td><span style="float:none">
        <a>
          <mat-icon style="color:blue; font-size:110%; padding-right:20px;"
          (click)="onOpenFormEdit(person)">edit</mat-icon>
        </a>
      </span>
    </td>
  </tr>
</ng-template>
</p-table>